import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import checkImg from '../../assets/img/check.svg';
import errorImg from '../../assets/img/erroricon.png';
import "../../Component/CommonPopup/commonPopup.css"
import { useEffect } from 'react';
import ErrorPopup from '../FallBackUI/ErrorPopup';
import Loading from '../../Component/Loading/Loading';
import { Button } from 'antd';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import moment from 'moment';
import PageNotFound from '../FallBackUI/PageNotFound';

const SealedBid = (props) => {
    const [loading, setLoading] = useState(true);
    const sellerData = useSelector(state => state.LoginReducer.payload);
    const [bidLists, setBidLists] = useState("");
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    useEffect(() => {
        BidList();
    }, []);

    const BidList = () => {
        let request = {
            car_id: props.carId,
            seller_id: sellerData.seller_id,
            seller_token: sellerData.seller_token,
        };

        API.post("sealedbidinfo/condition", request).then(response => {
            if (response.data.success === true) {
                setLoading(false);
                setBidLists(response.data.data);
            } else {
                setErrors(response.data.error.name);
                setErrorFlag(true);
            }
        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error);
                setErrorFlag(true);
            }
        });
    };

    function formatTime(value) {
        let local = new Date(value);
        let offset = local.getTimezoneOffset();
        value = new Date(local.getTime() - offset * 60000);
        value = moment(value).format('MMMM D, YYYY hh:mm A');
        return value;
    }

    return (

        <Modal show={true} onHide={props.toggle} size="xl" /* backdrop="static" keyboard={false} */>
            <Modal.Header className='Terms-login'>
                <h2 > Bid Details</h2>
            </Modal.Header>
            <Modal.Body>
                {errorFlag === true ? (
                    <PageNotFound error={errors} />
                ) : loading ? (
                    <Loading />
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <table class="bidinfo-table">
                            <thead className='Bidlist' >
                                <tr>
                                    <th className="sealrow">Buyer #</th>
                                    <th className="sealrow">Dealer Name</th>
                                    <th className="sealrow">Buyer Name</th>
                                    <th className="sealrow"> Amount</th>
                                    <th className="sealrow">Date & Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bidLists.length > 0 ? bidLists.sort().map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.buyer_id}</td>
                                        <td>{item.dealer_name}</td>
                                        <td>{item.buyername}</td>
                                        <td>${item.bid}</td>
                                        <td>{formatTime(item.date_tz)}</td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="5" className="text-center bit-list">
                                            <p>No Data Found</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}


                <div class="Close-info">
                    <button className="cta-btns-primary" onClick={props.toggle}>Close</button>

                </div>

            </Modal.Body>
        </Modal>
    );
};

export default SealedBid;
